import axios from "axios";
import { citiesOptions, stateOptions, ufOptions } from "../misc/customOptions";

export const cep_response = async (cep: any) => {
	try {
		const { data } = await axios.get(
			`https://viacep.com.br/ws/${cep}/json/`,
		);

		return data;
	} catch (error) {
		return error;
	}
};

export const list_states = async () => {
	try {
		const { data } = await axios.get(
			"https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome",
		);

		return data;
	} catch (error) {
		return error;
	}
};

export const list_countries = async () => {
	try {
		const { data } = await axios.get(
			"https://servicodados.ibge.gov.br/api/v1/paises/",
		);

		return data;
	} catch (error) {
		return error;
	}
};

export const get_city = async (id: string) => {
	try {
		const { data } = await axios.get(
			`https://servicodados.ibge.gov.br/api/v1/localidades/municipios/${id}`,
		);

		return data;
	} catch (error) {
		return error;
	}
};

export const get_state = async (id: string) => {
	try {
		const { data } = await axios.get(
			`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${id}`,
		);

		return data;
	} catch (error) {
		return error;
	}
};

export const get_country = async (id: string) => {
	try {
		const { data } = await axios.get(
			`https://servicodados.ibge.gov.br/api/v1/localidades/paises/${id}`,
		);

		return data;
	} catch (error) {
		return error;
	}
};


